import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import { CareersInner } from './CareersInner/CareersInner';

export type CareersProps = SliceComponentProps<Content.CareersSlice>;

const Careers = ({ slice }: CareersProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <CareersInner data={slice.primary} />
    </section>
  );
};

export default Careers;
